import axios from './axios';

export const getHeader = () => {
    const header = {
        headers: {
            'KGA-BACKOFFICE-API': 'cc05e420-a537-4fad-9df9-1d2745ef6f6a',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            "Content-Type": "application/json",
        }
    }
    return header;
}

export const getAuthHeader = () => {
    const token = 'Bearer ' + localStorage.getItem('useToken');
    const profileId = localStorage.getItem('profileId');

    const header = {
        headers: {
            Authorization: token,
            'KGA-BACKOFFICE-API': 'cc05e420-a537-4fad-9df9-1d2745ef6f6a',
            'KGA-USER-PROFILE': profileId,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            'Accept': "application/json",
            "Content-Type": "application/json",
        }
    }
    return header;
}

export const getAuthHeaderFD = () => {
    const token = 'Bearer ' + localStorage.getItem('useToken');
    const profileId = localStorage.getItem('profileId');

    const header = {
        headers: {
            Authorization: token,
            'KGA-BACKOFFICE-API': 'cc05e420-a537-4fad-9df9-1d2745ef6f6a',
            'KGA-USER-PROFILE': profileId,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            'Content-Type': 'multipart/form-data',
        }
    }
    return header;
}


export const postLogin = async (postdata) => {
    return await axios.post('/auth/login', postdata, getHeader()).then(res => {
        return res;
    })
}
export const postForgotPassword = async (postdata) => {
    return await axios.post('/forgotPassword', postdata, getHeader()).then(res => {
        return res;
    })
}
export const getOrgProfile = async () => {
    return await axios.get('/auth/get-org-profile', getAuthHeader()).then(res => {
        return res;
    })
}



//Master
export const postCommonMaster = async (postdata) => {
    return await axios.post('/common/masters', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postSectorAdd = async (postdata) => {
    return await axios.post('/sector/add', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postSector = async (postdata) => {
    return await axios.post('/sector', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getSectorDetails = async (id) => {
    return await axios.get('/sector/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const patchSectorUpdate = async (id, postdata) => {
    return await axios.patch('/sector/update/' + id, postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteSector = async (id) => {
    return await axios.delete('/sector/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postSubSector = async (id, postdata) => {
    return await axios.post('/sector/' + id, postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postSubSectorAdd = async (postdata) => {
    return await axios.post('/sector/sub/add', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

//Functions / Department
export const postPositionAdd = async (postdata) => {
    return await axios.post('/position/add', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postPosition = async (postdata) => {
    return await axios.post('/position', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getPositionDetails = async (id) => {
    return await axios.get('/position/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const patchPositionUpdate = async (id, postdata) => {
    return await axios.patch('/position/update/' + id, postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deletePosition = async (id) => {
    return await axios.delete('/position/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

export const postDesignationPosition = async (id, postdata) => {
    return await axios.post('/position/' + id, postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postDesignationAdd = async (postdata) => {
    return await axios.post('/position/designation/add', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//orgStage
export const postOrgStageSave = async (postdata) => {
    return await axios.post('/org-stage/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgStage = async (postdata) => {
    return await axios.post('/org-stage', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgStage = async (id) => {
    return await axios.get('/org-stage/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteOrgStage = async (id) => {
    return await axios.delete('/org-stage/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}


//Addupdate Address
export const postAddress = async (postdata) => {
    return await axios.post('/org-saved-address/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postlocationDetail = async (postdata) => {
    return await axios.post('/common/get-location-details', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrganizationProfile = async (postdata) => {
    return await axios.post('/organization/profile', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteAddressInfo = async (id) => {
    return await axios.delete('/org-saved-address/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//Addupdate Gst
export const postGst = async (postdata) => {
    return await axios.post('/org-gst/save', postdata, getAuthHeaderFD()).then(res => {
        return res;
    })
}
export const deleteGstInfo = async (id) => {
    return await axios.delete('org-gst/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//Addupdate Bank
export const postBanks = async (postdata) => {
    return await axios.post('org-bank-account/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteBanksInfo = async (id) => {
    return await axios.delete('org-bank-account/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}


//Addupdate Contact Person
export const postContact = async (postdata) => {
    return await axios.post('org-contact-person/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteContactInfo = async (id) => {
    return await axios.delete('org-contact-person/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//Organizations
export const postOrganization = async (postdata) => {
    return await axios.post('/organization', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrganizationAdd = async (postdata) => {
    return await axios.post('/organization/add', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrganizationUpdates = async (id, postdata) => {
    return await axios.patch('/organization/update/' + id, postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteOrganization = async (id) => {
    return await axios.delete('/organization/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrganizationComDetail = async (postdata) => {
    return await axios.post('/organization/details', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//Organization
export const postOrganizationDetail = async (postdata) => {
    return await axios.post('/organization/details', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//Client
export const postOrgClient = async (postdata) => {
    return await axios.post('/org-client', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgClientDetailss = async (cid, lid) => {
    const url = `/org-client/details/${cid}/${lid}`;
    return await axios.get(url, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgClientDetails = async (id) => {
    return await axios.get('/org-client/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgClientSave = async (postdata) => {
    return await axios.post('/org-client/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgClientSaveReferences = async (postdata) => {
    return await axios.post('/org-client/save-references', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteOrgClient = async (id) => {
    return await axios.delete('/org-client/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}


//VendorsPartner
export const postOrgVendorsPartner = async (postdata) => {
    return await axios.post('/org-vendor', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgVendorsPartnerDetails = async (id) => {
    return await axios.get('/org-vendor/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgVendorsPartnerSave = async (postdata) => {
    return await axios.post('/org-vendor/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgVendorsPartnerSaveReferences = async (postdata) => {
    return await axios.post('/org-vendor/save-references', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteOrgVendorsPartner = async (id) => {
    return await axios.delete('/org-vendor/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}


//Channel Partner
export const postOrgChannelPartner = async (postdata) => {
    return await axios.post('/org-channel-partner', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgChannelPartnerDetails = async (id) => {
    return await axios.get('/org-channel-partner/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgChannelPartnerSave = async (postdata) => {
    return await axios.post('/org-channel-partner/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgChannelPartnerSaveReferences = async (postdata) => {
    return await axios.post('/org-channel-partner/save-references', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteOrgChannelPartner = async (id) => {
    return await axios.delete('/org-channel-partner/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}



//Billing Entity
export const postOrgBillingEntity = async (postdata) => {
    return await axios.post('/org-billing-entity', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgBillingEntityDetails = async (id) => {
    return await axios.get('/org-billing-entity/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgBillingEntitySave = async (postdata) => {
    return await axios.post('/org-billing-entity/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgBillingEntitySaveReferences = async (postdata) => {
    return await axios.post('/org-billing-entity/save-references', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteOrgBillingEntity = async (id) => {
    return await axios.delete('/org-billing-entity/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}


//Associate Partner
export const postOrgAssociatePartner = async (postdata) => {
    return await axios.post('/org-associate-partner', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgAssociatePartnerDetails = async (id) => {
    return await axios.get('/org-associate-partner/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgAssociatePartnerSave = async (postdata) => {
    return await axios.post('/org-associate-partner/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgAssociatePartnerSaveReferences = async (postdata) => {
    return await axios.post('/org-associate-partner/save-references', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteOrgAssociatePartner = async (id) => {
    return await axios.delete('/org-associate-partner/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}


//Channel Partners
export const postCPOwnership = async (postdata) => {
    return await axios.post('/cp-ownership', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getCPOwnershipEmployee = async () => {
    return await axios.get('/cp-ownership/employee', getAuthHeader()).then(res => {
        return res;
    })
}
export const postCPOwnershipTransfer = async (postdata) => {
    return await axios.post('/cp-ownership/transfer', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

//Employee
export const postOrgEmployee = async (postdata) => {
    return await axios.post('/org-employee', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgEmployee = async () => {
    return await axios.get('/org-employee', getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgEmployeeDetails = async (id) => {
    return await axios.get('/org-employee/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgEmployeeSave = async (postdata) => {
    return await axios.post('/org-employee/save', postdata, getAuthHeaderFD()).then(res => {
        return res;
    })
}
export const deleteOrgEmployeeDelete = async (id) => {
    return await axios.delete('/org-employee/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const getOrgEmployeeContactPerson = async () => {
    return await axios.get('/org-employee/contact-person', getAuthHeader()).then(res => {
        return res;
    })
}


//Communication Log
export const postCommunicationLogDropdown = async (postdata) => {
    return await axios.post('/communication-log/dropdown', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postCommunicationLogHistory = async (postdata) => {
    return await axios.post('/communication-log/history', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postCommunicationLogSave = async (postdata) => {
    return await axios.post('/communication-log/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgContactPersonSearch = async (postdata) => {
    return await axios.post('/org-contact-person/search', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postOrgContactPersonSaveAccess = async (postdata) => {
    return await axios.post('/org-contact-person/save-access', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//Masters
export const postMasterType = async (postdata) => {
    return await axios.post('/master-type', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postMasterTypeSave = async (postdata) => {
    return await axios.post('/master-type/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postMasterTypeStatus = async (postdata) => {
    return await axios.post('/master-type/status', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteMasterType = async (id) => {
    return await axios.delete('/master-type/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}



//Sub Masters
export const postMasterData = async (postdata) => {
    return await axios.post('/master-data', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postMasterDataSave = async (postdata) => {
    return await axios.post('/master-data/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postMasterDataStatus = async (postdata) => {
    return await axios.post('/master-data/status', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postMasterDataChangeOrder = async (postdata) => {
    return await axios.post('/master-data/change-order', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteMasterData = async (id) => {
    return await axios.delete('/master-data/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//Documents
export const postDocument = async (postdata) => {
    return await axios.post('/documents', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getDocumentDetails = async (id) => {
    return await axios.get('/documents/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postDocumentSave = async (postdata) => {
    return await axios.post('/documents/save', postdata, getAuthHeaderFD()).then(res => {
        return res;
    })
}
export const deleteDocument = async (id) => {
    return await axios.delete('/documents/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postDocumentFileList = async (postdata) => {
    return await axios.post('/documents/files-list', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//Project Category
export const postProjectCategory = async (postdata) => {
    return await axios.post('/project-category', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getProjectCategory = async () => {
    return await axios.get('/project-category', getAuthHeader()).then(res => {
        return res;
    })
}
export const getProjectCategoryDetails = async (id) => {
    return await axios.get('/project-category/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const getProjectCategoryMap = async () => {
    return await axios.get('/project-category/category-map', getAuthHeader()).then(res => {
        return res;
    })
}
export const postProjectCategorySave = async (postdata) => {
    return await axios.post('/project-category/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteProjectCategory = async (id) => {
    return await axios.delete('/project-category/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//Product Category
export const postCategoryList = async (postdata) => {
    return await axios.post('/category', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postCategoryAdd = async (postdata) => {
    return await axios.post('/category/add', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getCategoryList = async () => {
    return await axios.get('/category', getAuthHeader()).then(res => {
        return res;
    })
}
export const patchCategoryUpdate = async (id, postdata) => {
    return await axios.patch('/category/update/' + id, postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteCategory = async (id) => {
    return await axios.delete('/category/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const getCategoryDetails = async (id) => {
    return await axios.get('/category/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const getCategorySub = async (id) => {
    return await axios.get('/category/sub/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postCategorySubAdd = async (postdata) => {
    return await axios.post('/category/sub/add', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postSubCategory = async (id, postdata) => {
    return await axios.post('/category/sub/' + id, postdata, getAuthHeader()).then(res => {
        return res;
    })
}

//products
export const postProduct = async (postdata) => {
    return await axios.post('/product', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProductSave = async (postdata) => {
    return await axios.post('/product/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getProductDetails = async (id) => {
    return await axios.get('/product/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteProduct = async (id) => {
    return await axios.delete('/product/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//Activity 
export const postActivity = async (postdata) => {
    return await axios.post('/activity', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postActivitySave = async (postdata) => {
    return await axios.post('/activity/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getActivityDetails = async (id) => {
    return await axios.get('/activity/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteActivity = async (id) => {
    return await axios.delete('/activity/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//Activity Template
export const postActivityTemplate = async (postdata) => {
    return await axios.post('/activity-template', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postActivityTemplateSave = async (postdata) => {
    return await axios.post('/activity-template/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getActivityTemplateDetails = async (id) => {
    return await axios.get('/activity-template/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteActivityTemplate = async (id) => {
    return await axios.delete('/activity-template/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

//CommunicationType

export const postCommunicationType = async (postdata) => {
    return await axios.post('/communication-type', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postCommunicationTypeSave = async (postdata) => {
    return await axios.post('/communication-type/save', postdata, getAuthHeaderFD()).then(res => {
        return res;
    })
}
export const getCommunicationTypeDetails = async (id) => {
    return await axios.get('/communication-type/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteCommunicationType = async (id) => {
    return await axios.delete('/communication-type/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postCommunicationTypeSaveStatus = async (postdata) => {
    return await axios.post('/communication-type/save-status', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

//projects
export const postProject = async (postdata) => {
    return await axios.post('/project', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProjectList = async (postdata) => {
    return await axios.post('/project/product-list', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProductActivityList = async (postdata) => {
    return await axios.post('/project/product-activity-list', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProductRoleList = async (postdata) => {
    return await axios.post('/project/role-list', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProjectSave = async (postdata) => {
    return await axios.post('/project/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteProject = async (id) => {
    return await axios.delete('/project/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const getProjectDetails = async (id) => {
    return await axios.get('/project/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const getProjectFullDetails = async (id) => {
    return await axios.get('/project/full-details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const getProjectActivityDetails = async (id) => {
    return await axios.get('/project/activity-details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postChangeActivityStatus = async (postdata) => {
    return await axios.post('/project/change-activity-status', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProjectActivityCompletionData = async (postdata) => {
    return await axios.post('/project/activity-completion-data', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProjectDocumentSave = async (postdata) => {
    return await axios.post('/project/documents/save', postdata, getAuthHeaderFD()).then(res => {
        return res;
    })
}
export const getProjectDocument = async (id) => {
    return await axios.get('/project/documents/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteProjectDocuments = async (id) => {
    return await axios.delete('/project/documents/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProjectSendMail = async (postdata) => {
    return await axios.post('/project/send-mail', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

//Leads
export const postLeads = async (postdata) => {
    return await axios.post('/leads', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postLeadSave = async (postdata) => {
    return await axios.post('/leads/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postProductList = async (postdata) => {
    return await axios.post('/leads/product-list', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const getLeadDetails = async (id) => {
    return await axios.get('/leads/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

export const postQuotationGenerate = async (postdata) => {
    return await axios.post('/quotation/generate', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const getLeadQuotation = async (id) => {
    return await axios.get('/quotation/lead-quotation/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

export const postShareDocument = async (postdata) => {
    return await axios.post('/leads/share-document', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postSendQuotation = async (postdata) => {
    return await axios.post('/quotation/send', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postLeadsCreateProject = async (postdata) => {
    return await axios.post('/leads/create-project', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getQuotationChangeStatus = async (id) => {
    return await axios.get('/quotation/change-status/' + id, getAuthHeader()).then(res => {
        return res;
    })
}


//EmailTemplate
export const postEmailTemplate = async (postdata) => {
    return await axios.post('/email-template', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postEmailTemplateSave = async (postdata) => {
    return await axios.post('/email-template/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const getEmailTemplate = async (id) => {
    return await axios.get('/email-template/details/' + id, getAuthHeader()).then(res => {
        return res;
    })
}
export const deleteEmailTemplate = async (id) => {
    return await axios.delete('/email-template/delete/' + id, getAuthHeader()).then(res => {
        return res;
    })
}

export const postEmailTemplateRenderBody = async (postdata) => {
    return await axios.post('/email-template/render-body', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//invoice
export const postInvoicePending = async (postdata) => {
    return await axios.post('/invoice/pending', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postInvoiceGenerate = async (postdata) => {
    return await axios.post('/invoice/generate', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postProjectPhaseDetails = async (postdata) => {
    return await axios.post('/project/phase-details', postdata, getAuthHeader()).then(res => {
        return res;
    })
}
export const postInvoice = async (postdata) => {
    return await axios.post('/invoice', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postInvoiceDetails = async (postdata) => {
    return await axios.post('/invoice/details', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postInvoiceMailMaster = async (postdata) => {
    return await axios.post('/invoice/mail-masters', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postInvoiceSend = async (postdata) => {
    return await axios.post('/invoice/send', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//Payment
export const postPaymentSave = async (postdata) => {
    return await axios.post('/payment/save', postdata, getAuthHeader()).then(res => {
        return res;
    })
}